// import bride1 from './images/bride3lookbook.jpg';
// import bride2 from './images/rsz_bride1.jpg';
// import bride3 from './images/rsz_bride4.jpg';
// import bride4 from './images/bride2lookbook.jpg';
// import bride5 from './images/rsz_bride5.jpg';
// // import bride6 from './images/rsz_bride6.jpg';
// import bride7 from './images/rsz_bride7.jpg';
// import bride8 from './images/rsz_bride8.jpg';
// import bride9 from './images/rsz_bride9.jpg';
// import bride10 from './images/rsz_bride10.jpg';
// import bride11 from './images/rsz_bride11.jpg';
// import bride12 from './images/rsz_bride12.jpg';
// import bride13 from './images/rsz_bride13.jpg';
// import bride14 from './images/rsz_bride14.jpg';
import bride1_1 from './images/bride1/DSC02655.jpg';
import bride1_2 from "./images/bride1/DSC02684.jpg";
import bride1_3 from './images/bride1/DSC02702.jpg';
import bride2_1 from './images/bride2/5D7A3685.jpg';
import bride2_2 from './images/bride2/5D7A3805.jpg';
import bride2_3 from './images/bride2/5D7A3840.jpg';
import bride2_4 from './images/bride2/DSC02596.jpg';
import bride2_5 from './images/bride2/DSC02625.jpg';
import bride3_1 from './images/bride3/5D7A4871.jpg';
import bride3_2 from './images/bride3/5D7A4854.jpg';
import bride4_1 from './images/bride4/5D7A4349.jpg';
import bride4_2 from './images/bride4/5D7A4398.jpg';
import bride4_3 from './images/bride4/5D7A4502.jpg';
import bride4_4 from './images/bride4/5D7A4540.jpg';
import bride4_5 from './images/bride4/5D7A4628.jpg';
import bride4_6 from './images/bride4/5D7A4631.jpg';
import bride5_1 from './images/bride5/5D7A4077.jpg';
import bride5_2 from './images/bride5/5D7A4166.jpg';
import bride5_3 from './images/bride5/5D7A4181.jpg';
import bride5_4 from './images/bride5/5D7A4192.jpg';
import bride5_5 from './images/bride5/5D7A4200.jpg';
import bride6_1 from './images/bride6/5D7A3461.jpg';
import bride6_2 from './images/bride6/5D7A3516.jpg';
import bride6_3 from './images/bride6/5D7A3547.jpg';
import bride6_4 from './images/bride6/5D7A3570.jpg';
import bride6_5 from './images/bride6/5D7A3639.jpg';
import carmen_1 from './images/Carmen/5D7A4980.jpg';
import carmen_2 from './images/Carmen/5D7A5004.jpg';
import carmen_3 from './images/Carmen/5D7A9008.jpg';
import carmen_4 from './images/Carmen/5D7A9283.jpg';
import carmen_5 from './images/Carmen/5D7A9794.jpg';
import carmen_6 from './images/Carmen/5D7A9880.jpg';
import carmen_7 from './images/Carmen/5D7A9936.jpg';
import bride7_1 from './images/bride7/5D7A3039.jpg';
import bride7_2 from './images/bride7/5D7A3064.jpg';
import bride7_3 from './images/bride7/5D7A3099.jpg';
import bride7_4 from './images/bride7/5D7A3118.jpg';




   export const dresses = [
        {
            "key": 1,
            "dressImg": [bride1_1, bride1_2, bride1_3],
            "name":"Ryan",
            "loading":"eager",
            "alt":"Off-white scalloped lace with an empire waist, sweetheart neck, and elbow length sleeves"
        },
        {
            "key": 2,
            "dressImg": [bride2_1, bride2_2, bride2_3, bride2_4, bride2_5],
            "name":"Ceteka",
            "loading":"lazy",
            "alt":"Hand beaded white lace with short sleeves, scoop neckline and chiffon bow train"
         },
        {
            "key": 3,
            "dressImg": [bride3_1, bride3_2],
            "name":"Carly",
            "loading":"lazy",
            "alt":"Creamy floral lace with v-neck, cap  sleeves, and flared skirt with train (detachable floral belt)"
        },
        {
            "key": 4,
            "dressImg": [bride4_1, bride4_2, bride4_3, bride4_4, bride4_5, bride4_6],
            "name":"Rylie",
            "loading":"lazy",
            "alt":"All-over white lace with bodice overlay and flared train with beaded gothic edge, scoop neckline, long sleeves with beaded wrist flounce"
        },
        {
            "key": 5,
            "dressImg": [bride5_1,bride5_2,bride5_3,bride5_4,bride5_5],
            "name":"Carrie",
            "loading":"lazy",
            "alt":"Ivory crepe with detachable satin train, hand beaded bodice with scoop neck and long sleeves"
        },
        {
            "key": 6,
            "dressImg": [bride6_1, bride6_2, bride6_3, bride6_4, bride6_5],
            "name":"Savannah",
            "loading":"lazy",
            "alt":"Fit and flare white crepe with split chiffon sleeves and wide button cuff"
        },
        {
            "key": 7,
            "dressImg": [carmen_1, carmen_2, carmen_3, carmen_4, carmen_5, carmen_6, carmen_7],
            "name":"Carmen",
            "loading":"lazy",
            "alt":"Off-white dupioni, corseted bodice with sweetheart neck, flutter sleeves, full tiered skirt with multiple tie ups for bustling options"
        },
        {
            "key": 8,
            "dressImg": [bride7_1, bride7_2, bride7_3, bride7_4],
            "name": "Haven",
            "loading":"lazy",
            "alt":"White crepe column with side rouching, cap sleeves, and narrow train"
        }
    ];
